<template>
  <div>
    <div class="event-properties-item">
      <div class="event-label">链接地址</div>
      <div>
        <el-input style="width:280px" size="mini" v-model="event.value" placeholder="要修改的目标ID或Tag，默认组件自身"></el-input>
        <!-- <el-input size="mini" v-model="event.value"></el-input> -->
      </div>
    </div>

    <div class="event-properties-item">
      <div class="event-label">打开方式</div>
      <div>
        <el-input
          size="mini"
          placeholder="_blank"
          v-model="event.params"
        ></el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["uuid", "technology"],
  data() {
    return {
      url: "",
      target: "_blank",
      event: {},
    };
  },
  created() {
    this.event = this.technology.getEvent(this.uuid);
    if(!this.event.params){
      this.event.params = this.target
    }
  },
};
</script>
<style lang="scss" scoped>
.event-properties-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .event-label {
    width: 120px;
  }
}
</style>